import * as types from "./solicitacao.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  changeState: new Date().getTime(),
  SituacaoSolicitacao: "Aguardando Avaliação",
  solicitacoes: [],
  itensComboboxCCM: [],
  disableTipoSolicitacao: true,
  TipoSolicitacao: undefined,
  CCM: undefined,
  CpfCnpjSolicitacao: undefined,
  TipoSolicitacaoAtual: 0,
  TipoSolicitacaoNumero: undefined,
  DescricaoSolicitacao: undefined,
  CcmDisabled: true
});

const reduce = (state = initialState, action = {}) => {
  let payload = action.payload;
  switch (action.type) {
    case types.SET_SOLICITACAO:
      return state.merge({ ...payload, changeState: new Date().getTime() });
    case types.SOLICITACAO_SET_COMBOBOXCCM:
      return state.merge({
        itensComboboxCCM: payload.itensCombobox,
        CpfCnpjSolicitacao: payload.cnpjCpf,
        changeState: new Date().getTime()
      });
    case types.SET_CCMTIPOSOLICITACAO:
      return state.merge({
        CCM: payload.ccm,
        TipoSolicitacao: payload.TipoSolicitacao,
        changeState: new Date().getTime()
      });
    case types.DESABILITADO_TIPOSOLICITACAO:
      return state.merge({
        disableTipoSolicitacao: payload,
        changeState: new Date().getTime()
      });
    case types.SET_REDUCER_CCM_DISABLED:
      return state.merge({ ...state, CcmDisabled: payload });
    case types.SET_TIPOSOLICITACAO:
      return state.merge({
        TipoSolicitacao: payload,
        changeState: new Date().getTime()
      });
    case types.SOLICITACAO_SET_CPFCNPJ:
      return state.merge({
        CpfCnpjSolicitacao: payload,
        changeState: new Date().getTime()
      });
    case types.SET_DESCRICAO_SOLICITACAO:
      return state.merge({...state, DescricaoSolicitacao: payload});
    case types.SET_TIPOSOLICITACAO_ATUAL:
      return state.merge({
        TipoSolicitacaoAtual: payload,
        changeState: new Date().getTime()
      });
    case types.SET_CCM:
      return state.merge({ CCM: payload, changeState: new Date().getTime() });
    default:
      return state;
  }
};

store.registerDynamicModule("solicitacao", reduce);
